import { ContractorsRequest } from '../ws/ContractorsRequest';
import { ContractorsBasicRequest } from '../ws/ContractorsBasicRequest';
import { ContractorsDetailRequest } from '../ws/ContractorsDetailRequest';
import { ContractorsDetailCurrentRequest } from '../ws/ContractorsDetailCurrentRequest';
import { ContractorsAddRequest } from '../ws/ContractorsAddRequest';
import { ContractorsUpdateRequest } from '../ws/ContractorsUpdateRequest';
import { ContractorsDeleteRequest } from '../ws/ContractorsDeleteRequest';
import { ContractorsSearchRequest } from '../ws/ContractorsSearchRequest';
import Alert from 'react-s-alert';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { push } from 'react-router-redux';
import { PsRoutes } from '../../shared/routing/Routes';
import * as sha256 from 'sha256';
import { PsContractor } from '../../my-contractors/contractor/PsContractor';

export const CONTRACTORS = {
    CLEAR: 'CONTRACTORS_CLEAR',
    FETCH_CONTRACTORS_SUCCEED: 'CONTRACTORS_FETCH_CONTRACTORS_SUCCEED',
    FETCH_CONTRACTORS_LOADING: 'CONTRACTORS_FETCH_CONTRACTORS_LOADING',
    FETCH_CONTRACTORS_BASIC_SUCCEED: 'CONTRACTORS_FETCH_CONTRACTORS_BASIC_SUCCEED',
    FETCH_CONTRACTORS_BASIC_LOADING: 'CONTRACTORS_FETCH_CONTRACTORS_BASIC_LOADING',
    FETCH_CONTRACTOR_SUCCEED: 'CONTRACTORS_FETCH_CONTRACTOR_SUCCEED',
    FETCH_CONTRACTOR_LOADING: 'CONTRACTORS_FETCH_CONTRACTOR_LOADING',
    FETCH_CONTRACTOR_CURRENT_SUCCEED: 'CONTRACTORS_FETCH_CONTRACTOR_CURRENT_SUCCEED',
    FETCH_CONTRACTOR_CURRENT_LOADING: 'CONTRACTORS_FETCH_CONTRACTOR_CURRENT_LOADING',
    CREATE_CONTRACTOR_SUCCEED: 'CONTRACTORS_CREATE_CONTRACTOR_SUCCEED',
    CREATE_CONTRACTOR_LOADING: 'CONTRACTORS_CREATE_CONTRACTOR_LOADING',
    UPDATE_CONTRACTOR_SUCCEED: 'CONTRACTORS_UPDATE_CONTRACTOR_SUCCEED',
    UPDATE_CONTRACTOR_LOADING: 'CONTRACTORS_UPDATE_CONTRACTOR_LOADING',
    DELETE_CONTRACTOR_SUCCEED: 'CONTRACTORS_DELETE_CONTRACTOR_SUCCEED',
    DELETE_CONTRACTOR_LOADING: 'CONTRACTORS_DELETE_CONTRACTOR_LOADING',
    CONTRACTORS_SEARCH_LOADING: 'CONTRACTORS_SEARCH_LOADING',
    CONTRACTORS_SEARCH_UPDATE: 'CONTRACTORS_SEARCH_UPDATE',
    CONTRACTORS_SEARCH_ERROR: 'CONTRACTORS_SEARCH_ERROR',
    CONTRACTOR_CREATE_FROM_COMPANY_CONFIRM_MODAL_DISPLAY: 'CONTRACTOR_CREATE_FROM_COMPANY_CONFIRM_MODAL_DISPLAY',
    CONTRACTORS_SHOW_FIELDS: 'CONTRACTORS_SHOW_FIELDS',
};

export const clearContractors = () => (dispatch) => {
    dispatch({
        type: CONTRACTORS.CLEAR,
    });
};

export const fetchContractors = (criteria) => (dispatch) => {

    new ContractorsRequest({ criteria })
        .onPreExecution(
            () => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTORS_LOADING,
                    payload: true,
                });
            },
        )
        .onSuccess(
            (res) => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTORS_SUCCEED,
                    payload: res,
                });
            },
        )
        .onFail(
            (error) => {
                Alert.error(error || I18nUtils.tr('TR_ERROR_OBTENER_CONTRATISTAS'));
            },
        )
        .onPostExecution(
            () => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTORS_LOADING,
                    payload: false,
                });
            },
        )
        .execute();

};

export const fetchContractorsBasic = (criteria) => (dispatch) => {

    new ContractorsBasicRequest({ criteria })
        .onPreExecution(
            () => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTORS_BASIC_LOADING,
                    payload: true,
                });
            },
        )
        .onSuccess(
            (res) => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTORS_BASIC_SUCCEED,
                    payload: res,
                });
            },
        )
        .onFail(
            (error) => {
                Alert.error(error || I18nUtils.tr('TR_ERROR_OBTENER_CONTRATISTAS'));
            },
        )
        .onPostExecution(
            () => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTORS_BASIC_LOADING,
                    payload: false,
                });
            },
        )
        .execute();

};

export const fetchContractor = (id) => (dispatch) => {

    const handleLoading = (payload) => dispatch({
        type: CONTRACTORS.FETCH_CONTRACTOR_LOADING,
        payload,
    });

    new ContractorsDetailRequest(id)
        .onPreExecution(() => handleLoading(true))
        .onSuccess(
            (res) => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTOR_SUCCEED,
                    payload: res,
                });
            },
        )
        .onFail(
            (error) => {
                Alert.error(error || I18nUtils.tr('TR_ERROR_OBTENER_CONTRATISTA'));
            },
        )
        .onPostExecution(() => handleLoading(false))
        .execute();

};

export const fetchContractorCurrent = () => (dispatch) => {

    new ContractorsDetailCurrentRequest()
        .onPreExecution(
            () => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTOR_CURRENT_LOADING,
                    payload: true,
                });
            },
        )
        .onSuccess(
            (res) => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTOR_CURRENT_SUCCEED,
                    payload: res,
                });
            },
        )
        .onFail(
            (error) => {
                Alert.error(error || I18nUtils.tr('TR_ERROR_OBTENER_CONTRATISTA_ACTUAL'));
            },
        )
        .onPostExecution(
            () => {
                dispatch({
                    type: CONTRACTORS.FETCH_CONTRACTOR_CURRENT_LOADING,
                    payload: false,
                });
            },
        )
        .execute();

};

export const createContractor = (values, contractorSearch = null, reuseCompanyIfExists = false) => (dispatch) => {

    const contractorSave = reuseCompanyIfExists ? values : parseToContractorSave(values);
    const handleLoading = (payload) => dispatch({
        type: CONTRACTORS.CREATE_CONTRACTOR_LOADING,
        payload,
    });

    contractorSave.disabled = false;

    if ( contractorSearch ) {
        const payload = { displayDialog: true, contractorSave };
        dispatch({ type: CONTRACTORS.CONTRACTOR_CREATE_FROM_COMPANY_CONFIRM_MODAL_DISPLAY, payload });

    } else {
        new ContractorsAddRequest(contractorSave, reuseCompanyIfExists)
            .onPreExecution(() => handleLoading(true))
            .onSuccess(
                (res) => {
                    Alert.success(I18nUtils.tr('TR_EXITO_CREAR_CONTRATISTA'));
                    dispatch({
                        type: CONTRACTORS.CREATE_CONTRACTOR_SUCCEED,
                        payload: res,
                    });
                    dispatch(push(PsRoutes.CONTRACTORS));
                },
            )
            .onFail((error) => {
                Alert.error(error || I18nUtils.tr('TR_ERROR_CREAR_CONTRATISTA'));
                handleLoading(false);
            })
            .onPostExecution(() => handleLoading(false))
            .execute();
    }
};

export const updateContractor = (values, contractor) => (dispatch) => {

    const contractorId = contractor.id;
    const companyId = contractor.company.id;
    const contractorSave = parseToContractorSave(values, companyId, contractorId);
    const handleLoading = (payload) => dispatch({
        type: CONTRACTORS.UPDATE_CONTRACTOR_LOADING,
        payload,
    });

    new ContractorsUpdateRequest(contractorSave, contractorId)
        .onSuccess(
            (res) => {
                Alert.success(I18nUtils.tr('TR_EXITO_ACTUALIZAR_CONTRATISTA'));
                dispatch({
                    type: CONTRACTORS.UPDATE_CONTRACTOR_SUCCEED,
                    payload: res,
                });
                dispatch(push(PsRoutes.CONTRACTORS));
            },
        )
        .onFail((error) => {
            Alert.error(error || I18nUtils.tr('TR_ERROR_ACTUALIZAR_CONTRATISTA'));
            handleLoading(false);
        })
        .onPostExecution(() => handleLoading(false))
        .execute();

};

// Si se emplea en un futuro tener en cuenta si debe o no eliminarse la empresa a la que está asociada.
export const deleteContractor = (id) => (dispatch) => {

    new ContractorsDeleteRequest(id)
        .onPreExecution(
            () => {
                dispatch({
                    type: CONTRACTORS.DELETE_CONTRACTOR_LOADING,
                    payload: true,
                });
            },
        )
        .onSuccess(
            (res) => {
                Alert.success(I18nUtils.tr('TR_EXITO_BORRAR_CONTRATISTA'));
                dispatch({
                    type: CONTRACTORS.DELETE_CONTRACTOR_SUCCEED,
                    payload: res,
                });
            },
        )
        .onFail(
            (error) => {
                Alert.error(error || I18nUtils.tr('TR_ERROR_BORRAR_CONTRATISTA'));
            },
        )
        .onPostExecution(
            () => {
                dispatch({
                    type: CONTRACTORS.DELETE_CONTRACTOR_LOADING,
                    payload: false,
                });
            },
        )
        .execute();

};

const parseToContractorSave = (values, companyId, id) => {

    const api = values.api
        ? {
            domain: values.apiDomain || undefined,
            api_base_url: values.apiBaseUrl || undefined,
            api_username: values.apiUsername || undefined,
            api_password: values.apiPassword || undefined,
        } : {
            domain: undefined,
            api_base_url: undefined,
            api_username: undefined,
            api_password: undefined,
        };

    const admin = values.admin ? {
        admin_name: values.adminName || undefined,
        admin_last_name: values.adminSurnames || undefined,
        admin_email: values.adminEmail || undefined,
        admin_password: values.adminPassword ? sha256(values.adminPassword) : undefined,
        admin_plain_password: values.adminPassword || undefined,
    } : {
        admin_name: undefined,
        admin_last_name: undefined,
        admin_email: undefined,
        admin_password: undefined,
        admin_plain_password: undefined,
    };

    const contractor = {
        id,
        company_id: companyId,
        name: values.contractorName || undefined,
        nif: values.contractorNif || undefined,
        contact_person: values.contractorContactPerson || undefined,
        phone: values.contractorPhone || undefined,
        email: values.contractorEmail || undefined,
        address: values.contractorAddress || undefined,
        ccc: values.contractorCcc || undefined,
        show_create_task_window: values.contractorShowCreateTaskWindow,
        disabled: !values.contractorEnabled,
        script_worker_states: values.contractorScriptWorkerStates || undefined,
        skip_rnt_check: values.contractorSkipRntCheck || false,
        skip_certificado_hacienda_contratista_check: values.contractorSkipAutomaticHaciendaCheck || false,
    };

    return {
        ...api,
        ...admin,
        ...contractor,
    };
};

export const searchContractor = (nif = '') => (dispatch) => {

    const handleLoading = (payload) => dispatch({
        type: CONTRACTORS.CONTRACTORS_SEARCH_LOADING,
        payload,
    });

    const handleShowFields = (show) => dispatch({
        type: CONTRACTORS.CONTRACTORS_SHOW_FIELDS,
        payload: show,
    });

    new ContractorsSearchRequest(nif)
        .onPreExecution(() => handleLoading(true))
        .onSuccess((res) => {
            const company = res.data.length !== 0 && res.data[0];
            if ( !!company ) {
                if ( company.is_also_contractor ) {
                    Alert.error(I18nUtils.tr('TR_LA_CONTRATA_QUE_INTENTA_ANADIR_YA_EXISTE'));
                    dispatch(() => handleShowFields(false));
                } else {
                    dispatch({
                        type: CONTRACTORS.CONTRACTORS_SEARCH_UPDATE,
                        payload: PsContractor.fromAPIContractor(company),
                    });
                    dispatch(() => handleShowFields(true));
                }
                dispatch(() => handleLoading(false));
            } else {
                dispatch(() => handleShowFields(true));
            }
        })
        .onFail((error) => {
            dispatch({ type: CONTRACTORS.CONTRACTORS_SEARCH_ERROR, payload: error });
            dispatch(() => handleLoading(false));
        })
        .onPostExecution(() => dispatch(() => handleLoading(false)))
        .execute();

};

export const clearContractorsForm = () => (dispatch) => {
    dispatch({ type: CONTRACTORS.CONTRACTORS_SEARCH_UPDATE, payload: null });
    dispatch({ type: CONTRACTORS.CONTRACTOR_CREATE_FROM_COMPANY_CONFIRM_MODAL_DISPLAY, payload: false });
    dispatch({ type: CONTRACTORS.CONTRACTORS_SHOW_FIELDS, payload: false });
};

export const setContractorCreateFromCompanyConfirmModalDisplay = (displayDialog) => (dispatch) => {
    const payload = { displayDialog };
    dispatch({ type: CONTRACTORS.CONTRACTOR_CREATE_FROM_COMPANY_CONFIRM_MODAL_DISPLAY, payload });
};



// WEBPACK FOOTER //
// ./src/app/contractors/actions/contractorsActions.js